import _defineProperty from "/src/main/react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _jsxFileName = "/src/main/react/src/main/app/components/admin/UserTable.js";
import React, { Fragment, Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from "react-router-dom";
import { Table, TableHead, TableBody, TableRow, TableCell, Grid, Typography, Button, LinearProgress } from '@material-ui/core';
import Util, { getSelectedPartner } from '../../util/Util';
import { isNotABlankString, objToString } from "../../util/StringUtil";
import { BASE_URIS, LOCAL_STORAGE_ITEM_NAMES, SESSION_STORAGE_ITEM_NAMES, TPIS_PARAMS } from "../domain/constants";
import { Check as Active, Close as Inactive } from '@material-ui/icons';
import { Pagination } from '../common';
import ManageUser, { MODE, visiblePartners } from "./ManageUser";
import Face from '@material-ui/icons/Face';

// Dialog Stuff
import Dialog from '@material-ui/core/Dialog';
import { Dialog as CustomDialog, SimpleSnackbar } from "../common";
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { changeSearchValue, determinePageFromQueryString, setUpPageInfoFromQueryString } from "../../util/QueryStringUtil";
import { HOMEPAGE } from "../Routes";
import { determineSelectedPartner } from "../../util/StorageUtil";
const styles = () => ({
  cell: {
    padding: 15,
    margin: 15
  },
  root: {
    width: '100%',
    marginTop: 0,
    overflowX: 'auto'
  },
  centeredContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    width: '80%'
  }
});
class UserTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      morePages: true,
      totalPages: 0,
      totalElements: 0,
      page: 0,
      pageSize: 10,
      sortField: 'username',
      sortDescending: false,
      loaded: false,
      // for editing users
      userIsSelected: false,
      selectedUser: null,
      updated: false
    };
    this.loadContent();
    this.deleteDialogRef = null;
    this.setDeleteDialogRef = element => {
      this.deleteDialogRef = element;
    };
    this.snackbar = null;
    this.setSnackbarRef = element => {
      this.snackbar = element;
    };
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    setUpPageInfoFromQueryString(this);

    // When the edit is successful, it will not automatically reload the table
    if (this.state.updated === true) {
      this.state.updated = false;
      this.loadContent();
    }
  }
  loadContent() {
    const _this$state = this.state,
      page = _this$state.page,
      pageSize = _this$state.pageSize,
      sortField = _this$state.sortField,
      sortDescending = _this$state.sortDescending;
    this.state.loaded = false;
    this.forceUpdate();
    const uri = BASE_URIS.prefix + BASE_URIS.listUsers + "?".concat(TPIS_PARAMS.PAGE, "=").concat(page) + "&".concat(TPIS_PARAMS.PAGE_SIZE, "=").concat(pageSize) + "&".concat(TPIS_PARAMS.SORT_FIELD, "=").concat(sortField) + "&".concat(TPIS_PARAMS.SORT_DESC, "=").concat(sortDescending);
    Util.fetchWithRedirect(uri, 'GET', this.props).then(resp => {
      this.state.users = resp.content;
      this.state.totalPages = resp.totalPages;
      this.state.totalElements = resp.totalElements;
      this.state.morePages = !resp.last;
      this.state.loaded = true;
      this.forceUpdate();
    }).catch(err => {
      console.error(err);
      Util.createDialog("Could not impersonate user", "Unable to impersonate user. See error in console", this.dialogRef);
    });
  }
  impersonate(user) {
    this.state.loaded = false;
    this.forceUpdate();
    let uri = BASE_URIS.prefix + BASE_URIS.impersonate + "?".concat(TPIS_PARAMS.USERNAME, "=").concat(user.username);
    fetch(uri, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'x-meta-tpic-partner': getSelectedPartner()
      }
    }).then(resp => {
      if (resp.ok === false) {
        Util.openSnackbar("You are not authorized to impersonate users. Contact your TPIC admins if you think this is incorrect", this.snackbar);
      }
      return resp.json();
    }).then(resp => {
      if (isNotABlankString(resp.username)) {
        localStorage.setItem(LOCAL_STORAGE_ITEM_NAMES.impersonatingUser, "true");
        localStorage.setItem(LOCAL_STORAGE_ITEM_NAMES.impersonatedUsername, resp.username);
        localStorage.setItem(LOCAL_STORAGE_ITEM_NAMES.impersonatedRole, resp.role);
        const partners = resp.visiblePartnerIdentifiers;
        localStorage.setItem(LOCAL_STORAGE_ITEM_NAMES.impersonatedVisiblePartners, objToString(partners));
        determineSelectedPartner(partners);
        console.log("there is 1 impostor among us");
        this.state.loaded = true;
        this.props.history.push(HOMEPAGE);
      }
    }).catch(err => {
      console.error(err);
      this.state.loaded = true;
      this.forceUpdate();
    });
  }
  render() {
    const classes = this.props.classes;
    const _this$state2 = this.state,
      users = _this$state2.users,
      userIsSelected = _this$state2.userIsSelected,
      selectedUser = _this$state2.selectedUser,
      loaded = _this$state2.loaded;
    const impersonationAllowed = sessionStorage.getItem(SESSION_STORAGE_ITEM_NAMES.IMPERSONATION_ALLOWED) === "true";
    return /*#__PURE__*/React.createElement("div", {
      style: {
        minHeight: '40vh',
        minWidth: '80vw',
        marginTop: 0
      },
      className: classes.root,
      id: "table-eid-".concat(this.state.entityId),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 172,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(SimpleSnackbar, {
      ref: this.setSnackbarRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 174,
        columnNumber: 17
      }
    }), /*#__PURE__*/React.createElement(DeleteDialog, {
      ref: this.setDeleteDialogRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 175,
        columnNumber: 17
      }
    }), userIsSelected === false && /*#__PURE__*/React.createElement(Fragment, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 178,
        columnNumber: 17
      }
    }, Pagination(this.state, this, classes, true), loaded === true && /*#__PURE__*/React.createElement(Table, {
      className: classes.root,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 181,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(TableHead, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 182,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(TableRow, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 183,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 184,
        columnNumber: 33
      }
    }, "Active"), impersonationAllowed === true && /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 186,
        columnNumber: 33
      }
    }, "Impersonate"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 188,
        columnNumber: 33
      }
    }, "Username"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 189,
        columnNumber: 33
      }
    }, "Email"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 190,
        columnNumber: 33
      }
    }, "ClientID"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 191,
        columnNumber: 33
      }
    }, "Role"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 192,
        columnNumber: 33
      }
    }, "Provider"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.cell,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 193,
        columnNumber: 33
      }
    }, "Visible Partners"))), /*#__PURE__*/React.createElement(TableBody, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 196,
        columnNumber: 25
      }
    }, users != null && users.length > 0 && users.map(user => /*#__PURE__*/React.createElement(TableRow, {
      id: user.id,
      hover: true,
      onClick: () => {
        this.setState({
          selectedUser: user,
          userIsSelected: true
        });
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 198,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(TableCell, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 201,
        columnNumber: 37
      }
    }, user.active === true ? /*#__PURE__*/React.createElement(Active, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 201,
        columnNumber: 72
      }
    }) : /*#__PURE__*/React.createElement(Inactive, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 201,
        columnNumber: 84
      }
    })), impersonationAllowed === true && /*#__PURE__*/React.createElement(TableCell, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 203,
        columnNumber: 37
      }
    }, /*#__PURE__*/React.createElement(Button, {
      variant: 'outlined',
      size: 'small',
      onClick: e => {
        // Prevent the click from also propogating down to the
        // table row which would open the ManageUser page
        e.preventDefault();
        e.stopPropagation();
        console.log("impersonate " + user.username);
        this.impersonate(user);
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 204,
        columnNumber: 41
      }
    }, /*#__PURE__*/React.createElement(Face, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 212,
        columnNumber: 52
      }
    }))), /*#__PURE__*/React.createElement(TableCell, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 215,
        columnNumber: 37
      }
    }, user.username), /*#__PURE__*/React.createElement(TableCell, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 216,
        columnNumber: 37
      }
    }, user.email), /*#__PURE__*/React.createElement(TableCell, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 217,
        columnNumber: 37
      }
    }, user.clientId), /*#__PURE__*/React.createElement(TableCell, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 218,
        columnNumber: 37
      }
    }, user.role), /*#__PURE__*/React.createElement(TableCell, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 219,
        columnNumber: 37
      }
    }, user.provider), /*#__PURE__*/React.createElement(TableCell, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 220,
        columnNumber: 37
      }
    }, partnersFromPartnerIds(user.visiblePartnerIds)))))), loaded === false && /*#__PURE__*/React.createElement(LinearProgress, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 226,
        columnNumber: 42
      }
    }), Pagination(this.state, this, classes, false)), userIsSelected === true && selectedUser != null && /*#__PURE__*/React.createElement(Fragment, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 232,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      style: {
        paddingTop: '10px'
      },
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      direction: 'column',
      spacing: 2,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 233,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      alignContent: 'center',
      alignItems: 'center',
      justify: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 235,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 236,
        columnNumber: 29
      }
    }, "Updating user: ", selectedUser.username)), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      spacing: 1,
      item: true,
      alignItems: 'center',
      alignContent: 'center',
      justify: 'center',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 238,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 240,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Button, {
      style: {
        paddingTop: '10px'
      },
      variant: "outlined",
      onClick: () => {
        this.setState({
          selectedUser: null,
          userIsSelected: false
        });
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 241,
        columnNumber: 33
      }
    }, "Cancel Update")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 245,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Button, {
      style: {
        paddingTop: '10px',
        color: 'red'
      },
      variant: "outlined",
      onClick: () => {
        this.deleteDialogRef.setUsername(selectedUser.username);
        this.deleteDialogRef.setUserId(selectedUser.id);
        this.deleteDialogRef.setParent(this);
        this.deleteDialogRef.handleClickOpen();
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 246,
        columnNumber: 33
      }
    }, "Delete User"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 254,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(ManageUser, {
      selectedUser,
      mode: MODE.UPDATE,
      parent: this,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 255,
        columnNumber: 29
      }
    })))));
  }
}
function partnersFromPartnerIds(partnerIds) {
  if (partnerIds == null) {
    return '?';
  } else {
    if (partnerIds.length === 0) {
      return 'N/A';
    } else {
      const knownPartnerIds = {};
      for (let partner of Object.keys(visiblePartners)) {
        knownPartnerIds[visiblePartners[partner].ID] = visiblePartners[partner].NAME;
      }
      let partners = '';
      let firstSet = false;
      for (let id of partnerIds) {
        if (firstSet === true) {
          partners += ', ';
        }
        let curr = knownPartnerIds[id];
        if (curr == null) {
          partners += id;
        } else {
          partners += curr;
        }
        firstSet = true;
      }
      return partners;
    }
  }
}
export default withStyles(styles)(withRouter(UserTable));
class DeleteDialog extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleClickOpen", () => {
      this.setState({
        open: true
      });
    });
    _defineProperty(this, "handleDelete", () => {
      const uri = BASE_URIS.prefix + BASE_URIS.deleteUser + "?".concat(TPIS_PARAMS.USER_ID, "=").concat(this.state.userId);
      fetch(uri, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'x-meta-tpic-partner': getSelectedPartner()
        }
      }).then(resp => {
        return resp.json();
      }).then(resp => {
        if (resp.status != null) {
          if (400 === resp.status) {
            this.setState({
              open: false
            });
            Util.createDialog('Failure', 'Bad Request. Message from server: ' + resp.message, this.dialogRef);
          } else if (401 === resp.status) {
            this.setState({
              open: false
            });
            Util.createDialog('Failure', 'Unauthorized request. Message from server: ' + resp.message, this.dialogRef);
          } else if (403 === resp.status) {
            this.setState({
              open: false
            });
            Util.createDialog('Failure', 'You are forbidden from deleting this user. Message from server: ' + resp.message, this.dialogRef);
          } else if (404 === resp.status) {
            this.setState({
              open: false
            });
            Util.createDialog('Failure', 'User not found. Message from server: ' + resp.message, this.dialogRef);
          } else {
            this.state.parent.setState({
              selectedUser: null,
              userIsSelected: false,
              updated: true
            });
            this.setState({
              open: false
            });
          }
        }
      }).catch(err => {
        console.dir(err);
      });
    });
    _defineProperty(this, "handleClose", () => {
      this.setState({
        open: false
      });
    });
    this.state = {
      open: false,
      username: props.username,
      userId: props.userId,
      parent: props.parent
    };
    this.dialogRef = null;
    this.setDialogRef = element => {
      this.dialogRef = element;
    };
  }
  setUsername(username) {
    this.state.username = username;
  }
  setUserId(userId) {
    this.state.userId = userId;
  }
  setParent(parent) {
    this.state.parent = parent;
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 375,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(CustomDialog, {
      ref: this.setDialogRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 376,
        columnNumber: 17
      }
    }), /*#__PURE__*/React.createElement(Dialog, {
      open: this.state.open,
      onClose: this.handleClose,
      "aria-labelledby": "form-dialog-title",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 377,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(DialogTitle, {
      id: "form-dialog-title",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 381,
        columnNumber: 21
      }
    }, "Delete User"), /*#__PURE__*/React.createElement(DialogContent, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 382,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(DialogContentText, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 383,
        columnNumber: 25
      }
    }, "Are you sure you want to delete user '", this.state.username, "'?")), /*#__PURE__*/React.createElement(DialogActions, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 387,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: this.handleDelete,
      color: "primary",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 388,
        columnNumber: 25
      }
    }, "Yes: Delete User"), /*#__PURE__*/React.createElement(Button, {
      onClick: this.handleClose,
      color: "primary",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 391,
        columnNumber: 25
      }
    }, "No: Cancel Delete"))));
  }
}